import Offtake from "./Offtake";
export default Offtake;
